// src/components/StatsPanel.js
import React, { useState, useEffect } from 'react';
import { WEB_APP_URL } from '../config';

// Cache helpers
const getCache = (key) => {
  try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
};

const MILESTONES = [
  { count: 5, emoji: '📖', label: 'Getting Started' },
  { count: 10, emoji: '📚', label: 'Bookworm' },
  { count: 25, emoji: '🌟', label: 'Avid Reader' },
  { count: 50, emoji: '🏆', label: 'Book Champion' },
  { count: 75, emoji: '👑', label: 'Reading Royalty' },
  { count: 100, emoji: '🎉', label: 'Century Club' },
];

const StatsPanel = ({ refreshToggle }) => {
  const cachedBooks = getCache('books');
  const [totalBooks, setTotalBooks] = useState(cachedBooks?.length || 0);
  const [loading, setLoading] = useState(!cachedBooks);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const response = await fetch(`${WEB_APP_URL}?action=getBooks`);
        const result = await response.json();
        setTotalBooks((result.books || []).length);
      } catch (error) {
        console.error('Error fetching books for stats:', error);
      }
      setLoading(false);
    };
    fetchBooks();
  }, [refreshToggle]);

  const achievedMilestones = MILESTONES.filter(m => totalBooks >= m.count);
  const nextMilestone = MILESTONES.find(m => totalBooks < m.count);

  return (
    <div className="stats-panel">
      <div className="total-books">
        <span className="total-number">{loading ? '...' : totalBooks}</span>
        <span className="total-label">books read all time</span>
      </div>
      
      {!loading && achievedMilestones.length > 0 && (
        <div className="milestones">
          <p className="milestones-label">Achievements:</p>
          <div className="milestone-badges">
            {achievedMilestones.map(m => (
              <span key={m.count} className="milestone-badge" data-tooltip={`${m.label} (${m.count} books)`}>
                {m.emoji}
              </span>
            ))}
          </div>
        </div>
      )}
      
      {!loading && nextMilestone && (
        <p className="next-milestone">
          {nextMilestone.count - totalBooks} more to unlock {nextMilestone.emoji} {nextMilestone.label}
        </p>
      )}
    </div>
  );
};

export default StatsPanel;
